module.exports = __webpack_public_path__ + "img/multiplier_0_th.4d00980f.png";